<ng-container [formGroup]="form">
  <app-form-address-tabs
    (activeTabIndexChanged)="onActiveTabIndexChange($event)"
  >
    <ng-container search-address-tab>
      <app-form-field
        [label]="'ADDRESS_ID_LABEL' | translate"
        formControlName="id"
      >
        <app-form-address-typeahead />
      </app-form-field>
    </ng-container>

    <ng-container manual-address-tab>
      <app-form-manual-address />

      <ng-container [ngTemplateOutlet]="isOverrideAddressFormField" />
    </ng-container>
  </app-form-address-tabs>

  @if (
    (isCommercialAddressSearchResult$ | async) &&
    (activeTabIndex$ | async) === 0
  ) {
    <div class="commerical-address-override">
      <svg
        class="commerical-address-override__icon"
        viewBox="0 0 60 60"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="30" cy="30" fill="currentColor" r="30" />
        <path
          d="M30.217 13.874L14.66 40.807a.2.2 0 00.171.3l30.66-.018a.2.2 0 00.179-.3l-15.024-26.9a.246.246 0 00-.429 0zM13.828 40.785l.635.367-.635-.367zm32.075 1.771H14.487a1.473 1.473 0 01-1.055-.4 1.423 1.423 0 01-.239-1.734l16-27.7a1.435 1.435 0 011.243-.715 1.433 1.433 0 011.253.736l15.439 27.642a1.451 1.451 0 01.161 1.1 1.433 1.433 0 01-1.389 1.061z"
          fill="#ffffff"
        />
        <path
          d="M30.328 32.749a1.467 1.467 0 01-1.467-1.467v-8.09a1.466 1.466 0 112.933 0v8.09a1.466 1.466 0 01-1.466 1.467z"
          fill="#ffffff"
        />
        <path
          d="M31.871 35.692a1.541 1.541 0 11-1.541-1.541 1.541 1.541 0 011.541 1.541z"
          fill="#ffffff"
        />
      </svg>
      <p class="commerical-address-override__title">
        {{ "ADDRESS_IS_OVERRIDE_ADDRESS_TITLE" | translate }}
      </p>

      @if (addressOverrideText()) {
        <p class="commerical-address-override__text">
          {{ addressOverrideText() }}
        </p>
      }

      <ng-container [ngTemplateOutlet]="isOverrideAddressFormField" />
    </div>
  }

  <ng-template #isOverrideAddressFormField>
    <app-form-field formControlName="isOverrideAddress">
      <app-form-checkbox [label]="addressOverrideCheckboxLabel()" />
    </app-form-field>
  </ng-template>
</ng-container>
